import { OrganizationType } from '@/lib/enums/OrganizationType'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/imports')({
  component: OrganizationImportsLayout,
  loader: async ({ context, params }) => {
    if (!context.ability.can('access', 'global') || !context.ability.can('edit', 'organizations')) {
      throw notFound()
    }

    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.orgId)
    )

    if (
      organization?.type !== OrganizationType.Florist.Value &&
      organization?.type !== OrganizationType.Global.Value
    ) {
      throw notFound()
    }

    return { organization }
  },
})

function OrganizationImportsLayout() {
  return <Outlet />
}
